import { createServerFn } from "@tanstack/react-start";

/**
 * Returns the Google Analytics measurement ID (G-XXXXXXX) from the server
 * secret store. A measurement ID is public by design, so it is safe to send
 * to the browser — but it lives in a server-only secret, so it must be
 * fetched via this server function rather than read client-side.
 */
export const getGaMeasurementId = createServerFn({ method: "GET" }).handler(
  async () => {
    const id = process.env["GOOGLE_ANALYTICS_MEASUREMENT_ID"]?.trim();
    return { measurementId: id && id.length > 0 ? id : null };
  },
);
